function Page404() {
    return <div className="flex flex-1 items-center justify-center h-screen">
        <div className="mx-2">
            <h1 className="text-5xl my-5">404</h1>
        </div>
        <div>
            <h2 className="text-2xl">找不到檔案</h2>
            <h2 className="text-2xl">Not Found</h2>
        </div>
    </div>
}

export default Page404